import {
  PimLanguageRoute_default
} from "./chunk-H3RESY6F.js";

// src/Pim/PimLanguage/PimLanguage.ts
import axios from "axios";
var AesirxPimLanguageApiService = class {
  constructor() {
    this.route = null;
    this.getList = async (filter = {}) => {
      try {
        const data = await this.route.getList(filter);
        let items = [];
        if (data?._embedded?.item) {
          items = data._embedded.item.map((o) => ({
            label: o?.name ?? "",
            value: o?.code ?? "",
            isDefault: !!o?.is_default,
            code: o?.code ?? "",
            flag: o?.flag ?? ""
          }));
        }
        return items;
      } catch (error) {
        if (axios.isCancel(error)) {
          return { message: "isCancel" };
        } else
          throw error;
      }
    };
    this.route = new PimLanguageRoute_default();
  }
};

export {
  AesirxPimLanguageApiService
};
/*
 * @copyright   Copyright (C) 2022 AesirX. All rights reserved.
 * @license     GNU General Public License version 3, see LICENSE.
 */
